(function () {
  function initHero(root) {
    if (!root || root.__rhInit) return;
    root.__rhInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.rh__slide'));
    if (!slides.length) return;
    var segs = Array.prototype.slice.call(root.querySelectorAll('.rh__seg'));
    var interval = parseInt(root.getAttribute('data-interval'), 10);
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var mq = window.matchMedia('(max-width: 749px)');

    var idx = 0, timer = null;
    // Герой в окне (или нет); видео стоит (ещё не пошло, буферизуется, на паузе); полоса видео идёт.
    var onScreen = true, stalled = false, running = false;

    function isVideo(i) { return slides[i].getAttribute('data-type') === 'video'; }
    function video(i) { return slides[i].querySelector('.rh__video'); }

    function applyVideoSources(v) {
      if (!v) return;
      var src = mq.matches ? v.getAttribute('data-src-mobile') : v.getAttribute('data-src-desktop');
      if (src && v.getAttribute('data-cur') !== src) {
        v.src = src;
        v.setAttribute('data-cur', src);
        try { v.load(); } catch (e) {}
      }
      // Both sides, not just mobile: the markup no longer ships a literal `poster` (it made phones
      // download the desktop file too), so a rotation into landscape has nothing to fall back on
      // unless we set the desktop one here. Same URLs the preloads used — a swap, not a fetch.
      // Сверка с атрибутом, не со свойством: v.poster отдаёт абсолютный адрес (https://…), в
      // атрибуте лежит //rotas69.lv/…, и проверка по свойству не совпадала никогда — тот же постер
      // переписывался при каждом показе слайда.
      var poster = v.getAttribute(mq.matches ? 'data-poster-mobile' : 'data-poster-desktop');
      if (poster && v.getAttribute('poster') !== poster) v.poster = poster;
    }

    var curVideo = null;
    function clearTimers() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (curVideo) {
        curVideo.removeEventListener('playing', onPlaying);
        curVideo.removeEventListener('pause', onStall);
        curVideo.removeEventListener('waiting', onStall);
        curVideo = null;
      }
    }

    // Полоса прогресса — CSS-анимация rh-fill (стили в sections/rotas-hero.liquid): скрипт ставит
    // классы при смене слайда, заполнение рисует браузер. Раньше скрипт сам писал style.transform:
    // фото — таймером каждые 250 мс, видео — на каждый timeupdate, и так всё время, пока открыта
    // страница, даже когда герой давно за краем экрана. Каждая запись — мутация DOM, которую пишет
    // запись сессии Clarity: замер 01.11.2026 — 4 в секунду, больше трети всех мутаций главной в
    // покое. Теперь вне экрана, в скрытой вкладке и пока видео стоит, анимация на паузе (is-paused).
    function syncPause() {
      root.classList.toggle('is-paused', !onScreen || stalled || document.hidden);
    }
    function resetSegs() {
      for (var k = 0; k < segs.length; k++) {
        segs[k].classList.toggle('is-done', k < idx);
        segs[k].classList.toggle('is-run', false);
        var cur = k === idx ? 'true' : 'false';
        if (segs[k].getAttribute('aria-current') !== cur) segs[k].setAttribute('aria-current', cur);
      }
    }
    // Заполнить сегмент текущего слайда за durMs, начиная с fromMs. is-alt меняет имя анимации —
    // только так сегмент перезапускается с нуля, если он уже шёл в этом же кадре.
    function runSeg(durMs, fromMs) {
      var s = segs[idx];
      if (!s) return;
      s.style.setProperty('--rh-dur', Math.round(durMs) + 'ms');
      s.style.setProperty('--rh-delay', -Math.round(fromMs) + 'ms');
      s.classList.toggle('is-alt');
      s.classList.toggle('is-run', true);
    }

    // Полоса видео стартует вровень с ним: по событию playing (первый кадр, конец буферизации) и по
    // обещанию play() — оно сработает и тогда, когда видео уже играло и playing больше не придёт.
    function onPlaying() {
      var v = video(idx);
      if (!v || v !== curVideo || (running && !stalled)) return;
      stalled = false;
      if (v.duration) { runSeg(v.duration * 1000, v.currentTime * 1000); running = true; }
      syncPause();
    }
    function onStall() {
      stalled = true;
      running = false;
      syncPause();
    }
    function armVideoTimer(v) {
      if (curVideo !== v || !v.duration) return;
      clearTimeout(timer);
      timer = setTimeout(next, (v.duration - v.currentTime) * 1000 + 400);
    }
    function startVideo(v) {
      if (v.readyState >= 1) armVideoTimer(v);
      else v.addEventListener('loadedmetadata', function () { armVideoTimer(v); }, { once: true });
      var p = v.play();
      if (p && p.then) p.then(function () { if (curVideo === v && !v.paused) onPlaying(); }, function () {});
    }
    function pauseAll() {
      slides.forEach(function (s) {
        var v = s.querySelector('.rh__video');
        if (v) { try { v.pause(); } catch (e) {} }
      });
    }

    function show(i) {
      clearTimers();
      idx = (i % slides.length + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      resetSegs();
      stalled = false;
      running = false;
      if (!autoplay) { syncPause(); return; }

      if (isVideo(idx)) {
        var v = video(idx);
        if (!v) { syncPause(); return; }
        applyVideoSources(v);
        try { v.currentTime = 0; } catch (e) {}
        var onEnded = function () { v.removeEventListener('ended', onEnded); next(); };
        v.addEventListener('ended', onEnded);
        curVideo = v;
        v.addEventListener('playing', onPlaying);
        v.addEventListener('pause', onStall);
        v.addEventListener('waiting', onStall);
        // До первого кадра полоса стоит на нуле; пойдёт с событием playing, вровень с видео.
        stalled = true;
        syncPause();
        if (onScreen && !document.hidden) startVideo(v);
      } else {
        pauseAll();
        runSeg(interval, 0);
        syncPause();
      }
    }
    function next() { show(idx + 1); }

    // Фото переключает конец анимации его сегмента: пауза анимации — пауза и смены слайда.
    root.addEventListener('animationend', function (e) {
      var s = segs[idx];
      if (!autoplay || isVideo(idx) || !s || e.target !== s.firstElementChild) return;
      next();
    });

    // Вне экрана герой стоит: полоса на паузе, видео тоже, страховочный таймер видео снят.
    // Вернулся — продолжает с того же места.
    function setOnScreen(on) {
      if (on === onScreen) return;
      onScreen = on;
      syncPause();
      if (!autoplay || document.hidden || !isVideo(idx)) return;
      var v = video(idx);
      if (!v || curVideo !== v) return;
      if (on) startVideo(v);
      else {
        if (timer) { clearTimeout(timer); timer = null; }
        try { v.pause(); } catch (e) {}
      }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        setOnScreen(entries[entries.length - 1].isIntersecting);
      }).observe(root);
    }

    segs.forEach(function (s) {
      s.addEventListener('click', function () { show(parseInt(s.getAttribute('data-goto'), 10) || 0); });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimers(); pauseAll(); syncPause(); }
      else { show(idx); }
    });

    var onMq = function () {
      if (isVideo(idx)) {
        var v = video(idx);
        applyVideoSources(v);
        if (autoplay && v && onScreen) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
      }
    };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);

    var first = video(0);
    if (first) applyVideoSources(first);
    show(0);
  }

  function boot() {
    document.querySelectorAll('rotas-hero').forEach(initHero);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('rotas-hero') : []).forEach(function (el) {
      el.__rhInit = false;
      initHero(el);
    });
  });
})();
